import { z } from 'zod';

const warningsSchema = z.array(z.unknown());
const messageSchema = z.string().trim().min(1);

/** Parses independent warning messages, retaining valid entries for presentation. */
export function parseUserWarnings(value: unknown): {
  messages: string[];
  invalidCount: number;
} {
  if (value === undefined) return { messages: [], invalidCount: 0 };
  const parsed = warningsSchema.safeParse(value);
  if (!parsed.success) return { messages: [], invalidCount: 1 };

  const messages = new Set<string>();
  let invalidCount = 0;
  for (const entry of parsed.data) {
    const message = messageSchema.safeParse(entry);
    if (message.success) messages.add(message.data);
    else invalidCount += 1;
  }
  return { messages: [...messages], invalidCount };
}
